// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { blockVariantSideOptions } from "@store/Library/Components/Toolkit/Block/variant/base";
import { blockVariantOptions } from "@store/Library/Components/Toolkit/Block/variant/config";
import { getDataOption, getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";

const blockVariantSideField = {
    ...getDataOptionsFieldDefinition(blockVariantSideOptions),
    displayName: "Variant Side",
    tooltip: "Determines on which side to apply the variant styles (Default: Both Sides)",
    hideEmptyOption: true,
    isVisible: x => getDataOption(blockVariantOptions, x?.fields?.blockVariant)?.hasSideVariant || false,
} as DropDownFieldDefinition<string>;

export default blockVariantSideField;
